import { jdiColorFetch } from '@/apis/colorFetchV2';
import { TERMINAL } from '@/constants/cms';

// 1st page best seller data
export const fetchBestSellerData = async ({
  currentPage,
  pageSize = 10,
  sequenceId = null,
}: any) => {
  return await jdiColorFetch('marketing_rank_getCategoryTabs', {
    method: 'POST',
    bodyQuery: {
      productBestSellerRankSize: 8,
      currentPage,
      pageSize,
      sequenceId,
    },
  });
};
// Get sidebar data
export const fetchSideBarData = async ({
  sequenceId,
  level,
}: {
  sequenceId?: string;
  level?: string;
}) => {
  return await jdiColorFetch('marketing_rank_getCategoryTree', {
    method: 'POST',
    bodyQuery: {
      sequenceId,
      level,
      terminal: TERMINAL.PC,
    },
  });
};

export const fetchBestSellerRankProducts = async ({ sequenceId }: any) => {
  return await jdiColorFetch('marketing_rank_getItemList', {
    method: 'POST',
    bodyQuery: {
      sequenceId,
    },
  });
};

export const fetchRecommendCategoryData = async ({
  sequenceId,
  currentPage,
}: {
  sequenceId?: string;
  currentPage: number;
}) => {
  return await jdiColorFetch('marketing_rank_getRecommendCategory', {
    method: 'POST',
    bodyQuery: {
      currentPage,
      pageSize: 6,
      productBestSellerRankSize: 3,
      sequenceId,
    },
  });
};
